/**
 * redux引用入口文件
 */
import { createStore } from "redux";
import rootReducer from "./reducers";

export default createStore(
    rootReducer,
)




// WEBPACK FOOTER //
// ./src/redux/store.js